import { useTheme } from 'styled-components';
// @ts-expect-error untype dependency
import growthImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/growth-analytics-icon.svg';
// @ts-expect-error untype dependencys
import homepageImageUrl from 'bender-url!marketplace-assets-base/img/templates-homepage/homepage-icon.svg';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Big from 'UIComponents/elements/Big';
import UISection from 'UIComponents/section/UISection';
import { AudioInputOutputIcon, BulbIcon, CapIcon, CartIcon, ContactDuplicateIcon, DateIcon, DesktopIcon, GiftIcon, KeyIcon, LanguageIcon, ListsIcon, SalesQuoteIcon, SocialHeartIcon, StylesIcon, TagIcon, ThemeIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Image } from 'foundations-components/transitional/components/Image';
import { getAssetBusinessTypeTranslationKey } from 'marketplace-ui-assets-core/utils/i18n';
import Carousel from 'marketplace-ui-common/components/Carousel';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import StorefrontSection from 'marketplace-ui-common/storefront/components/StorefrontSection';
import { Fragment, useMemo } from 'react';
import UIRouterButton from 'ui-addon-react-router-dom/UIRouterButton';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import AssetBusinessTypeUrls from '../../constants/urls/AssetBusinessType';
import { useUsedBusinessTypeValues } from '../../hooks/useUsedBusinessTypeValues';
import ThemeCollectionsCardGrid from '../../storefront/components/ThemeCollectionsCardGrid';
import { getAllThemeCollectionsRoute, getThemesStorefrontRoute } from '../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ASSET_BUSINESS_TYPE_ICON_MAP = {
  ART_ENTERTAINMENT: StylesIcon,
  CUSTOMER_SERVICE: AudioInputOutputIcon,
  ECOMMERCE: GiftIcon,
  EVENT_MANAGEMENT: DateIcon,
  FINANCIAL_SERVICES: SalesQuoteIcon,
  FOOD_BEVERAGE: TagIcon,
  HEALTH_BEAUTY: SocialHeartIcon,
  HR_RECRUITING: ListsIcon,
  MARKETING: BulbIcon,
  NONPROFIT_EDUCATION: CapIcon,
  PROFESSIONAL_SERVICES: ContactDuplicateIcon,
  REAL_ESTATE: KeyIcon,
  RETAIL: CartIcon,
  SMALL_BUSINESS: ThemeIcon,
  TECHNOLOGY: DesktopIcon,
  TRAVEL_HOSPITALITY: LanguageIcon
};
function BusinessTypeIcon({
  type
}) {
  const Icon = ASSET_BUSINESS_TYPE_ICON_MAP[type];
  return /*#__PURE__*/_jsx(Icon, {
    size: "800"
  });
}
function ThemesInnerSection({
  children
}) {
  return /*#__PURE__*/_jsx(View, {
    marginInline: "1100",
    paddingBlockStart: "1300",
    paddingInline: "1000",
    as: "div",
    children: children
  });
}
export default function ThemesSection({
  onTrackInteraction
}) {
  const trellisTheme = useTheme();
  const businessTypeValues = useUsedBusinessTypeValues();
  const {
    direction,
    maxCardsPerPage,
    width
  } = useResponsiveProps({
    direction: {
      [ScreenSizes.XS]: 'column',
      [ScreenSizes.MD]: 'row'
    },
    maxCardsPerPage: {
      [ScreenSizes.SM]: 2,
      [ScreenSizes.MD]: 3,
      [ScreenSizes.LG]: 5
    },
    width: {
      [ScreenSizes.XS]: undefined,
      [ScreenSizes.MD]: '50%'
    }
  });
  const businessTypeCards = useMemo(() => businessTypeValues.map((businessType, index) => /*#__PURE__*/_jsx(UIRouterButton, {
    to: getThemesStorefrontRoute(AssetBusinessTypeUrls[businessType]),
    use: "unstyled",
    height: "85px",
    onMouseOver: e => {
      e.currentTarget.style.textDecoration = 'none';
      e.currentTarget.style.color = trellisTheme.color['do-not-use-eerie'];
    },
    onMouseOut: e => {
      e.currentTarget.style.color = 'inherit';
    },
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(BusinessTypeIcon, {
        type: businessType
      }), /*#__PURE__*/_jsx(Text, {
        textAlign: "center",
        marginBlockStart: "300",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: getAssetBusinessTypeTranslationKey(businessType)
        })
      })]
    })
  }, index)), [businessTypeValues, trellisTheme]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(ThemesInnerSection, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        flexDirection: "column",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          color: "text-core-default",
          role: "heading",
          typography: "heading-600",
          textAlign: "center",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.themes.title"
          })
        }), /*#__PURE__*/_jsxs(Flex, {
          flexDirection: direction,
          marginInlineEnd: "0",
          padding: "1000",
          justifyContent: "center",
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            flexDirection: "column",
            marginInlineEnd: "400",
            inlineSize: width,
            children: [/*#__PURE__*/_jsx(Image, {
              blockSize: "200px",
              src: homepageImageUrl,
              role: "presentation"
            }), /*#__PURE__*/_jsx(Text, {
              as: "h3",
              textAlign: "center",
              typography: "heading-400",
              marginBlockEnd: "400",
              role: "heading",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.templates.themes.simpleUseTitle"
              })
            }), /*#__PURE__*/_jsx(Text, {
              textAlign: "center",
              children: /*#__PURE__*/_jsx(Big, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.templates.themes.simpleUseSubtitle"
                })
              })
            })]
          }), /*#__PURE__*/_jsxs(Flex, {
            alignItems: "center",
            flexDirection: "column",
            marginInlineStart: "400",
            inlineSize: width,
            children: [/*#__PURE__*/_jsx(Image, {
              blockSize: "200px",
              src: growthImageUrl,
              role: "presentation"
            }), /*#__PURE__*/_jsx(Text, {
              as: "h3",
              textAlign: "center",
              typography: "heading-400",
              marginBlockEnd: "400",
              role: "heading",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-assets-ui.templates.themes.analyticsTitle"
              })
            }), /*#__PURE__*/_jsx(Text, {
              textAlign: "center",
              children: /*#__PURE__*/_jsx(Big, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "marketplace-assets-ui.templates.themes.analyticsSubtitle"
                })
              })
            })]
          })]
        }), /*#__PURE__*/_jsx(UIRouterButton, {
          onClick: () => {
            onTrackInteraction('click themes storefront link');
          },
          style: {
            width
          },
          to: getThemesStorefrontRoute(),
          use: "tertiary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.themes.button"
          })
        })]
      })
    }), /*#__PURE__*/_jsxs(ThemesInnerSection, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "heading-400",
        marginBlockEnd: "900",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.themes.browseByIndustryTitle"
        })
      }), /*#__PURE__*/_jsx(Carousel, {
        cards: businessTypeCards,
        gutterSize: 10,
        maxCardsPerPage: maxCardsPerPage,
        showPagination: false
      })]
    }), /*#__PURE__*/_jsx(ThemesInnerSection, {
      children: /*#__PURE__*/_jsx(StorefrontSection, {
        primaryGridSize: 9,
        subtitle: /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "0",
          as: "p",
          children: /*#__PURE__*/_jsx(Big, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.templates.themes.themeCollectionsSubtitle"
            })
          })
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.templates.themes.themeCollectionsTitle"
        }),
        titleControls: /*#__PURE__*/_jsx(UIRouterLink, {
          onClick: () => onTrackInteraction('all collections link'),
          to: getAllThemeCollectionsRoute(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "marketplace-assets-ui.templates.themes.collectionsLink"
          })
        }),
        titleControlsMobile: "md",
        children: /*#__PURE__*/_jsx(UISection, {
          use: "island",
          children: /*#__PURE__*/_jsx(ThemeCollectionsCardGrid, {})
        })
      })
    })]
  });
}